/* Lotus Edition slideshow */
(function () {
  var sliders = document.querySelectorAll('[data-lx-slider]');
  Array.prototype.forEach.call(sliders, function (s) {
    var slides = Array.prototype.slice.call(s.querySelectorAll('.lx-slide'));
    var dots = Array.prototype.slice.call(s.querySelectorAll('.lx-slider__dot'));
    var pbtn = s.querySelector('.lx-slider__pause');
    if (slides.length < 2) return;
    var i = 0, timer = null, held = false;
    var paused = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function go(n) {
      slides[i].classList.remove('is-on'); slides[i].setAttribute('aria-hidden', 'true');
      if (dots[i]) { dots[i].classList.remove('is-on'); dots[i].removeAttribute('aria-current'); }
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on'); slides[i].removeAttribute('aria-hidden');
      if (dots[i]) { dots[i].classList.add('is-on'); dots[i].setAttribute('aria-current', 'true'); }
    }
    function stop() { clearInterval(timer); timer = null; }
    function play() { stop(); if (!paused && !held) timer = setInterval(function () { go(i + 1); }, 6000); }
    function setPaused(p) {
      paused = p;
      if (pbtn) {
        pbtn.classList.toggle('is-paused', p);
        pbtn.setAttribute('aria-pressed', p ? 'true' : 'false');
        pbtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
      }
      play();
    }
    Array.prototype.forEach.call(s.querySelectorAll('[data-dir]'), function (b) {
      b.addEventListener('click', function () { go(i + (+b.getAttribute('data-dir'))); play(); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(+d.getAttribute('data-go')); play(); });
    });
    if (pbtn) pbtn.addEventListener('click', function () { setPaused(!paused); });
    var track = s.querySelector('.lx-slider__track');
    track.addEventListener('mouseenter', function () { held = true; stop(); });
    track.addEventListener('mouseleave', function () { held = false; play(); });
    s.addEventListener('focusin', function () { held = true; stop(); });
    s.addEventListener('focusout', function () { held = false; play(); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 45) { go(i + (dx < 0 ? 1 : -1)); play(); }
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    setPaused(paused);
  });
})();

/* Sticky section tabs (La Vallee style) */
(function () {
  var group = document.getElementById('header-group'), sub = document.querySelector('.lx-subnav');
  if (!group || !sub) return;
  var track = sub.querySelector('.lx-subnav__track');
  function stick() {
    group.style.top = -(group.offsetHeight - sub.offsetHeight) + 'px';
    document.documentElement.style.scrollPaddingTop = (sub.offsetHeight + 12) + 'px';
  }
  stick();
  window.addEventListener('resize', stick);
  window.addEventListener('load', stick);
  var links = Array.prototype.slice.call(sub.querySelectorAll('a'));
  function setActive(a) {
    links.forEach(function (l) { l.classList.toggle('is-active', l === a); });
    if (a && track) track.scrollTo({ left: Math.max(0, a.offsetLeft - 20), behavior: 'smooth' });
  }
  links.forEach(function (a) { a.addEventListener('click', function () { setActive(a); }); });
  /* Home: on the home page it goes back to the top; elsewhere it opens the home page */
  var home = sub.querySelector('[data-home]'), isHome = !!document.getElementById('shop');
  document.querySelectorAll('[data-home]').forEach(function (h) {
    h.addEventListener('click', function (e) {
      if (!isHome) return;
      e.preventDefault();
      var dr = h.closest('.lx-drawer'), mb = document.querySelector('.lx-menu-btn');
      if (dr && mb && mb.getAttribute('aria-expanded') === 'true') mb.click();
      var reduce = document.documentElement.hasAttribute('data-a11y-motion') || matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      if (home) setActive(home);
    });
  });
  function links_set(a) {
    links.forEach(function (l) { if (l === a) l.setAttribute('aria-current', 'page'); else if (l.hasAttribute('data-home')) l.removeAttribute('aria-current'); });
  }
  if (home && isHome) {
    var atTop = function () { if (window.scrollY < 120) { if (!home.classList.contains('is-active')) setActive(home); links_set(home); } else if (home.classList.contains('is-active')) links_set(null); };
    window.addEventListener('scroll', atTop, { passive: true });
    atTop();
  }
  if ('IntersectionObserver' in window) {
    var map = {};
    links.forEach(function (a) { var id = a.getAttribute('data-spy'); if (id) map[id] = a; });
    var io = new IntersectionObserver(function (es) {
      if (home && isHome && window.scrollY < 120) return;
      es.forEach(function (e) { if (e.isIntersecting && map[e.target.id]) { setActive(map[e.target.id]); links_set(null); } });
    }, { rootMargin: '-35% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
  }
})();
